import React, { createRef, useEffect, useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import stylePropType from 'react-style-proptype';

import { PortalContext, PortalProvider } from '../../../providers/PortalProvider';
import { ModalBackdrop, ModalBody } from '../../atoms';

const Modal = ({
  children = () => null,
  className = null,
  onClose = null,
  size = null,
  bodyStyle = null,
  closeOnBackdropClick = false
}) => {
  const backdrop = createRef();
  const { hidePortal } = useContext(PortalContext);

  useEffect(() => {
    document.body.style = 'overflow: hidden';

    return () => {
      document.body.style = 'overflow: auto';
    };
  }, []);

  const close = useCallback(() => {
    if (onClose) onClose();
    hidePortal();
  }, []);

  const handleEscapeKeyPress = (event) => {
    if (event.key === 'Escape') {
      close();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleEscapeKeyPress);
    return () => window.removeEventListener('keydown', handleEscapeKeyPress);
  }, [handleEscapeKeyPress]);

  const handleBackdropClick = (e) => {
    if (closeOnBackdropClick && e.target === backdrop.current) {
      close();
    }
  };

  return (
    <ModalBackdrop ref={backdrop} className={className} onClick={handleBackdropClick}>
      <ModalBody size={size} style={bodyStyle}>
        <PortalProvider>{children(close)}</PortalProvider>
      </ModalBody>
    </ModalBackdrop>
  );
};

Modal.propTypes = {
  children: PropTypes.func,
  className: PropTypes.string,
  onClose: PropTypes.func,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  bodyStyle: stylePropType,
  closeOnBackdropClick: PropTypes.bool
};

export { Modal };
